module.exports = __webpack_public_path__ + "img/banner4.d2de3c6c.jpg";